import httpCodes from '@/constants/httpCodes';

export default function getHttpStatus(status: number) {
  return httpCodes[status] as string | undefined;
}
